import { Company } from '@models/business/Company'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Avatar, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { selectCompanyById } from '../../../store/business/CompanyReducer'
import { useAppSelector } from '../../../store/hooks'

const { Text } = Typography

type Props = SBModelComponent<Company> & {}

export const CompanyAvatar = ({ id, model }: Props) => {
  const item = model ? model : useAppSelector(selectCompanyById(id!))
  if (!item) {
    return <></>
  }

  return (
    <Link style={{ color: 'black' }} to={`/business/companies/${item.id}`}>
      <Space>
        <Avatar
          style={{
            color: '#fff',
            backgroundColor: '#8e978a',
            border: 0,
            cursor: 'pointer',
          }}
        >
          <div style={{ textTransform: 'uppercase' }}>
            {item.name && item.name.slice(0, 1)}
          </div>
        </Avatar>
        {item.name && <Text>{item.name}</Text>}
      </Space>
    </Link>
  )
}

export type CompanyAvatarType = { Avatar: typeof CompanyAvatar }
